function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="35" height="35" viewBox="0 0 35 35" {...props}><path fillRule="evenodd" d="M15.525 17.146L1.383 3.004 3.504.883l14.143 14.142L32.496.175l2.121 2.122-14.85 14.85 14.85 14.849-2.121 2.12-14.85-14.848L2.798 34.117.676 31.996z" /></svg>;
});